import { Typography } from '@mui/material'
import ConfirmDialog from 'components/Dialog/ConfirmDialog'
import { useLoginContext } from 'pages/LoginPage/LoginProvider'
import { useTranslation } from 'react-i18next'

function OverrideLoginPopup() {
    const {
        isWarningDuplicationLogin,
        cancelForceLogin,
        forceLogin,
    } = useLoginContext()
    const { t } = useTranslation()

    return (
        <ConfirmDialog
            open={isWarningDuplicationLogin}
            title={t('login.message.duplicate_login')}
            fullWidth
            maxWidth="sm"
            confirmText={'YES'}
            onSave={forceLogin}
            onDiscard={cancelForceLogin}
            discardBtnText={'NO'}
        >
            <Typography>{t('login.message.force_login')}</Typography>
        </ConfirmDialog>
    )
}

export default OverrideLoginPopup
